import React from "react";

const HoldOnIcon = ({width, height}) => {
  return (
    <svg
      width={width || "40"}
      height={height || "40"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="39.5"
        height="39.5"
        rx="7.75"
        fill="#FFF4DD"
        stroke="#FEB519"
        stroke-width="0.5"
      />
      <circle cx="20" cy="20" r="12" fill="#FEB519" />
      <path
        d="M25.0001 12.292C25.0001 11.9468 24.7203 11.667 24.3751 11.667C24.0299 11.667 23.7501 11.9468 23.7501 12.292V26.1997L21.9003 24.3501C21.6562 24.106 21.2606 24.106 21.0165 24.3501C20.7724 24.5942 20.7724 24.9898 21.0165 25.2339L23.9332 28.1506C24.1772 28.3947 24.5729 28.3947 24.817 28.1506L27.7337 25.2339C27.9778 24.9898 27.9778 24.5942 27.7337 24.3501C27.4896 24.106 27.0939 24.106 26.8498 24.3501L25.0001 26.1997V12.292ZM12.6042 14.8981C12.6042 13.1145 14.0501 11.6686 15.8337 11.6686C17.6173 11.6686 19.0632 13.1145 19.0632 14.8981C19.0632 17.3562 18.0589 20.368 17.5539 21.7344C17.2841 22.4645 16.5881 22.9166 15.8355 22.9166C15.0809 22.9166 14.3839 22.4622 14.1149 21.7302C13.6104 20.3577 12.6042 17.3304 12.6042 14.8981ZM15.8337 12.9186C14.7405 12.9186 13.8542 13.8049 13.8542 14.8981C13.8542 17.0841 14.7823 19.9227 15.2881 21.2991C15.3678 21.5157 15.5796 21.6666 15.8355 21.6666C16.0909 21.6666 16.3018 21.5165 16.3814 21.3012C16.8867 19.9338 17.8132 17.1099 17.8132 14.8981C17.8132 13.8049 16.927 12.9186 15.8337 12.9186ZM13.7501 26.2521C13.7501 25.101 14.6832 24.1678 15.8343 24.1678C16.9855 24.1678 17.9186 25.101 17.9186 26.2521C17.9186 27.4032 16.9855 28.3363 15.8343 28.3363C14.6832 28.3363 13.7501 27.4032 13.7501 26.2521ZM15.8343 25.4178C15.3736 25.4178 15.0001 25.7913 15.0001 26.2521C15.0001 26.7128 15.3736 27.0863 15.8343 27.0863C16.2951 27.0863 16.6686 26.7128 16.6686 26.2521C16.6686 25.7913 16.2951 25.4178 15.8343 25.4178Z"
        fill="white"
      />
    </svg>
  );
};

export default HoldOnIcon;
